import api from './api'

/** GET /user/api-keys */
export function fetchApiKeys() {
  return api.get('/user/api-keys')
}

/** POST /user/api-keys */
export function createApiKey(name) {
  return api.post('/user/api-keys', { name: name || undefined })
}

/** POST /user/api-keys/{id}/revoke */
export function revokeApiKey(id) {
  return api.post(`/user/api-keys/${encodeURIComponent(id)}/revoke`)
}

/** DELETE /user/api-keys/{id} */
export function deleteApiKey(id) {
  return api.delete(`/user/api-keys/${encodeURIComponent(id)}`)
}

/** 兼容 { code, data } 与直接 data */
export function pickApiPayload(res) {
  if (!res) return null
  if (res.data !== undefined && res.data !== null && typeof res.data === 'object' && !Array.isArray(res.data)) {
    // { code:0, data:{ list } } 或 { list } 已在 data 层
    if (Array.isArray(res.data.list) || res.data.key || res.data.id !== undefined) {
      return res.data
    }
  }
  if (Array.isArray(res.list) || res.key || res.max !== undefined) {
    return res
  }
  if (res.data !== undefined && res.data !== null && typeof res.data === 'object') {
    return res.data
  }
  return res
}

export function maskSecret(s) {
  const str = String(s || '')
  if (str.length <= 8) return '********'
  return str.slice(0, 6) + '••••••••' + str.slice(-4)
}
